export default __webpack_public_path__ + "static/media/mpn-picturemark-d.feee0f00.svg";